import {
    CREATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK,
    CREATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK,
    CREATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK,
    DELETE_PRINTING_DC_INWARD_MASTER_REQUEST_DK,
    DELETE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK,
    DELETE_PRINTING_DC_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_FAILURE_DK,
    FETCH_PRINTING_DC_INWARD_MASTER_REQUEST_DK,
    FETCH_PRINTING_DC_INWARD_MASTER_SUCCESS_DK,
    FETCH_PRINTING_DC_INWARD_MASTER_FAILURE_DK,
    UPDATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK,
    UPDATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK,
    UPDATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK,
    RESET_PRINTING_DC_INWARD_MASTER_INFO_DK,
    CREATE_PRINTING_DC_INWARD_MASTER_FORM_DK,
    UPDATE_PRINTING_DC_INWARD_MASTER_FORM_DK,
    NAVIGATE_PRINTING_DC_INWARD_DETAILS_DK,
    NAVIGATE_PRINTING_DC_INWARD_MASTER_DK,
    FETCH_PENDING_PRINTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_PRINTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_PRINTING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_PRINTING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_PRINTING_INWARD_ID_DK,
    FETCH_COMPLETE_PRINTING_DC_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_PRINTING_DC_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_PRINTING_DC_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK,
    SET_PENDING_GRID_NAME_PRINTING_INWARD_DK,
    SET_UNIT_NAME_PRINTING_INWARD_DK
} from './printingDcInwardHeader.actionsType';

export const PRINTING_DC_INWARD_MASTER_DK = 'printingDcInwardHeaderDK';

let initialState = {
    loading: false,
    printingDcInwardHeader: [],
    pendingPrintingDC: [],
    completePrintingDC: [],
    reportSinglePrintingDCProgramInwardList: [],
    printingDcInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: 0,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedState: {},
    errorMessage: '',
    activeKey: 1,
    renderGridBtn: 'pendingGrid',
    unitId: '',
    printingInwardId: '',
    detailsId: [],
    singlePrintingDcInwardData: {},
    isPrintingDcInwardDetails: false
};

export let printingDcInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRINTING_DC_INWARD_MASTER_REQUEST_DK:
        case FETCH_PENDING_PRINTING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK:
        case UPDATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_REQUEST_DK:
        case DELETE_PRINTING_DC_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_COMPLETE_PRINTING_DC_IN_INWARD_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeader: updatePayload
            };
        case FETCH_PENDING_PRINTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingPrintingDC: updatePayload
            };
        case FETCH_COMPLETE_PRINTING_DC_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completePrintingDC: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSinglePrintingDCProgramInwardList: updatePayload?.Inward
            };
        case CREATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                printingInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case SET_ACTIVE_KEY_PRINTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_PRINTING_INWARD_DK:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_PRINTING_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case RESET_PRINTING_DC_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                printingInwardId: '',
                detailsId: [],
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_PRINTING_INWARD_ID_DK:
            return {
                ...state,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case CREATE_PRINTING_DC_INWARD_MASTER_FORM_DK:
        case UPDATE_PRINTING_DC_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    ...state.printingDcInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PRINTING_DC_INWARD_MASTER_FAILURE_DK:
        case FETCH_PENDING_PRINTING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK:
        case UPDATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_FAILURE_DK:
        case DELETE_PRINTING_DC_INWARD_MASTER_FAILURE_DK:
        case FETCH_COMPLETE_PRINTING_DC_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PRINTING_DC_INWARD_DETAILS_DK:
            return {
                ...state,
                isPrintingDcInwardDetails: true,
                singlePrintingDcInwardData: updatePayload.singlePrintingDcInwardData
            };
        case NAVIGATE_PRINTING_DC_INWARD_MASTER_DK:
            return {
                ...state,
                isPrintingDcInwardDetails: false
            };
        default:
            return state;
    }
};
